import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.interceptors.response.use((response) => {
  const { data } = response;

  if (data.UserWebToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${data.UserWebToken}`;
  }

  return response;
});

export default class DataSvc {
  /* Auth Endpoints */
  static signIn(credentials) {
    return axios.post('signin', credentials).then(response => response.data);
  }
  /* / Auth Endpoints */

  /* Customer Endpoints */
  static getCustomers() {
    return axios.get('customers').then(response => response.data.Customers);
  }

  static getCustomer(id) {
    return axios.get(`customer?id=${id}`).then(response => response.data.Customer);
  }

  static createCustomer(customer) {
    return axios.post('customer', customer).then(response => response.data.Customer);
  }

  static updateCustomer(customer) {
    return axios.put('customer', customer).then(response => response.data.Customer);
  }
  /* / Customer Endpoints */

  /* Features Endpoints */
  static getFeatures() {
    return axios.get('features').then(response => response.data.Features);
  }
  /* / Features Endpoints */

  /* License Endpoints */
  static getLicenses() {
    return axios.get('licenses').then(response => response.data.Licenses);
  }

  static getLicense(id) {
    return axios.get(`license?id=${id}`).then(response => response.data.License);
  }

  static createLicense(license) {
    return axios.post('license', license).then(response => response.data.License);
  }

  static updateLicense(license) {
    return axios.put('license', license).then(response => response.data.License);
  }

  static revokeLicenses(licenses) {
    const list = _.cloneDeep(licenses);
    const promises = [];

    list.forEach((l) => {
      [l.ExpirationDate] = moment().startOf('day').toISOString().split('T');
      promises.push(this.updateLicense(l));
    });

    return Promise.all(promises);
  }
  /* / License Endpoints */

  /* Usage Endpoints */
  static approveUsage(usage) {
    return axios.put('usage', usage);
  }
  /* / Usage Endpoints */

  /* Software Update Endpoints */
  static getSoftwareUpdates() {
    return axios.get('software-updates').then(response => response.data.Updates);
  }

  static uploadSoftwareUpdate(version, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`software-update/upload?version=${encodeURIComponent(version)}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  }

  static releaseSoftwareUpdate(version) {
    return axios.post('software-update/release', { Version: version });
  }

  static revokeSoftwareUpdate(version) {
    return axios.post('software-update/revoke', { Version: version });
  }

  static deleteSoftwareUpdate(version) {
    return axios.delete(`software-update/delete?version=${encodeURIComponent(version)}`);
  }

  static downloadSoftwareUpdate(version) {
    return axios.get(`software-update/download?version=${encodeURIComponent(version)}`)
      .then(response => response.data.Url);
  }
  /* / Software Update Endpoints */
}
